import type { RicosEntity, RicosEntityMap } from '../../../types';

export const createEntity = (
  key: number,
  { type, mutability, data }: RicosEntity
): RicosEntityMap => {
  return { [key.toString()]: { type, mutability, data } };
};
